module.exports = __webpack_public_path__ + "img/400.fd30fb19.jpg";